<template>
  <div
    class="gx-shead"
    :class="{ 'gx-shead--in': visible }"
    :style="{ '--gx-ac': ac }"
  >
    <div class="gx-shead__line">
      <span class="gx-shead__dash gx-shead__dash--l"></span>
      <span class="gx-shead__en">{{ en }}</span>
      <span class="gx-shead__dash gx-shead__dash--r"></span>
    </div>
    <h2 class="gx-shead__zh">{{ zh }}</h2>
    <p v-if="sub" class="gx-shead__sub">{{ sub }}</p>
    <div class="gx-shead__bar"></div>
  </div>
</template>

<script>
export default {
  name: 'SectionHead',
  props: {
    en: { type: String, required: true },
    zh: { type: String, required: true },
    sub: { type: String, default: '' },
    ac: { type: String, default: 'var(--gx-member-accent, #D4A946)' },
    visible: { type: Boolean, default: true }
  }
}
</script>

<style scoped>
.gx-shead {
  text-align: center;
  margin-bottom: 60px;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity var(--gx-member-motion-base, 0.65s) ease,
    transform var(--gx-member-motion-base, 0.65s) var(--gx-member-ease, cubic-bezier(.22, 1, .36, 1));
}
.gx-shead--in {
  opacity: 1;
  transform: none;
}
.gx-shead__line {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
}
.gx-shead__dash {
  display: block;
  width: 32px;
  height: 1px;
}
.gx-shead__dash--l {
  background: linear-gradient(90deg, transparent, var(--gx-ac));
}
.gx-shead__dash--r {
  background: linear-gradient(90deg, var(--gx-ac), transparent);
}
.gx-shead__en {
  font-family: var(--gx-member-font-mono, Inter, monospace);
  font-size: 10px;
  color: var(--gx-ac);
  letter-spacing: 4.5px;
  font-weight: 700;
}
.gx-shead__zh {
  font-family: var(--gx-member-font-display, 'Noto Serif SC', serif);
  font-size: clamp(22px, 2.8vw, 32px);
  font-weight: 700;
  color: var(--gx-member-text, #F0EBE0);
  margin: 0 0 12px;
  background: linear-gradient(140deg, #F0EBE0 0%, var(--gx-ac) 45%, #F0EBE0 80%);
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: gx-shimmer 7s 1s linear infinite;
}
.gx-shead__sub {
  font-family: var(--gx-member-font-sans, 'Noto Sans SC', sans-serif);
  font-size: 15px;
  color: rgba(220, 215, 240, .65);
  margin: 0 0 18px;
}
.gx-shead__bar {
  width: 48px;
  height: 2px;
  border-radius: 1px;
  background: linear-gradient(90deg, #D4A946, var(--gx-ac));
  margin: 0 auto;
  box-shadow: 0 0 12px rgba(212, 169, 70, .5);
}
</style>
